























































































import Vue from 'vue'
export default Vue.extend({
  data() {
    return {
      currnetBp: 'lg',
    }
  },
  methods: {
    updateBp(bp: string) {
      this.currnetBp = bp
      this.$emit('breakpoints', bp)
    },
  },
})
